<div class="advanced-coordinates__coordinates-container">
  <div class="advanced-coordinates__coordinates-container__inner">
    @if (units) {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{
          'igo.integration.advanced-map-tool.advanced-coordinates.lon'
            | translate
        }}</mat-label>
        <textarea
          #textArea
          matInput
          readonly
          rows="1"
          [placeholder]="
            'igo.integration.advanced-map-tool.advanced-coordinates.lon'
              | translate
          "
          [value]="coordinates[0]"
        ></textarea>
      </mat-form-field>
    } @else {
      <mat-form-field subscriptSizing="dynamic">
        <textarea
          #textArea
          matInput
          readonly
          rows="1"
          [placeholder]="
            'igo.integration.advanced-map-tool.advanced-coordinates.est'
              | translate
          "
          [value]="coordinates[0]"
        ></textarea>
      </mat-form-field>
    }

    @if (units) {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{
          'igo.integration.advanced-map-tool.advanced-coordinates.lat'
            | translate
        }}</mat-label>
        <textarea
          #textArea
          matInput
          readonly
          rows="1"
          [placeholder]="
            'igo.integration.advanced-map-tool.advanced-coordinates.lat'
              | translate
          "
          [value]="coordinates[1]"
        ></textarea>
      </mat-form-field>
    } @else {
      <mat-form-field subscriptSizing="dynamic">
        <textarea
          #textArea
          matInput
          readonly
          rows="1"
          [placeholder]="
            'igo.integration.advanced-map-tool.advanced-coordinates.nord'
              | translate
          "
          [value]="coordinates[1]"
        ></textarea>
      </mat-form-field>
    }
    <button
      mat-icon-button
      [attr.aria-label]="
        'igo.integration.advanced-map-tool.advanced-coordinates.copy'
          | translate
      "
      class="igo-form-button-group advanced-coordinates__copy-coordinates"
      (click)="copyTextToClipboard()"
    >
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>

  <form class="igo-form advanced-coordinates__form" [formGroup]="form">
    <div class="advanced-coordinates__coordinates-container__inner">
      <mat-form-field class="igo-input-container" subscriptSizing="dynamic">
        <mat-label>{{
          'igo.integration.advanced-map-tool.advanced-coordinates.coordSystem'
            | translate
        }}</mat-label>
        <mat-select [(value)]="inputProj">
          @for (projection of projections$ | async; track projection) {
            <mat-option
              matTooltipShowDelay="500"
              [value]="projection"
              (click)="$event.stopPropagation()"
            >
              {{ projection.translatedValue || projection.alias }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="advanced-coordinates__coordinates-container__inner">
      <mat-slide-toggle
        class="center-toggle"
        [checked]="center"
        [labelPosition]="'before'"
        (change)="displayCenter($event.checked)"
      >
        {{
          'igo.integration.advanced-map-tool.advanced-coordinates.center'
            | translate
        }}
      </mat-slide-toggle>
    </div>
  </form>

  <p class="igo-zoom">
    {{
      'igo.integration.advanced-map-tool.advanced-coordinates.zoom' | translate
    }}
    {{ map.viewController.getZoom() }}
  </p>
  <p class="igo-zoom">
    {{
      'igo.integration.advanced-map-tool.advanced-coordinates.scale' | translate
    }}
    {{ formattedScale$ | async }}
  </p>
  <p class="igo-zoom">
    {{
      'igo.integration.advanced-map-tool.advanced-coordinates.resolution'
        | translate
    }}
    {{ map.viewController.getResolution() | number: '1.0-0' }}
  </p>
</div>
